import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Select from "react-select";
import "./AdmCircularEntry.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useClassSections from "../../hooks/useClassSections";
import { fetchInitiatedByList } from "../../hooks/fetchInitiatedByList";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

const CircularEntry = () => {
  const navigate = useNavigate();
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [filteredMessages, setFilteredMessages] = useState([]);
  const [circularMessages, setCircularMessages] = useState([]);
  const [circularDate, setCircularDate] = useState("");
  const [circularTime, setCircularTime] = useState("");
  const [issuedBy, setIssuedBy] = useState(null);
  const [circularDetails, setCircularDetails] = useState("");
  const [sendSmsTo, setSendSmsTo] = useState("Both");
  const [uploadCircular, setUploadCircular] = useState(null);
  const [previewCircular, setPreviewCircular] = useState(null); // 🔹 for preview
  const [sendSms, setSendSms] = useState(false);
  const [smsText, setSmsText] = useState("");
  const [flashCircular, setFlashCircular] = useState(false);
  const [flashSite, setFlashSite] = useState(false);
  const [displaySite, setDisplaySite] = useState(false);
  const [approved, setApproved] = useState(false);
  const [initiatedByList, setInitiatedByList] = useState([]);
  const [filters, setFilters] = useState({
    classIds: [],
    sectionIds: [],
    initiatedById: "",
  });
  const [academicYearId, setAcademicYearId] = useState(
    localStorage.getItem("academicSessionId")
  );
  const [createdBy, setCreatedBy] = useState(sessionStorage.getItem("userId"));
  const [orgId, setOrgId] = useState(localStorage.getItem("orgId"));
  const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
  const [initiatedBy, setInitiatedBy] = useState(null);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  // const handleInitiatedByChange = (e) => setInitiatedBy(e.target.value);
  const handleInitiatedByChange = (e) => {
    const newValue = e.target.value;
    setSelectedInitiatedBy(newValue); // Update the dropdown value
    setInitiatedBy(newValue); // Optional: Update if needed elsewhere
  };
  const [selectAllSection, setSelectAllSection] = useState(false);
  const { classes, loading, error } = useFetchClasses();
  const [classSelections, setClassSelections] = useState({});
  const [selectAllClass, setSelectAllClass] = useState(false);
  const { classSections, loadings, errors } = useClassSections();
  const [selections, setSelections] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [sectionSelections, setSectionSelections] = useState({});
  // const [initiatedByList, setInitiatedByList] = useState([]);
  const [selectedInitiatedBy, setSelectedInitiatedBy] = useState("");
  const [fetchedData, setFetchedData] = useState(null); // Add this state
  const [selectedCircularId, setSelectedCircularId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // you can adjust this
  const [isCancelEnabled, setIsCancelEnabled] = useState(false);
  const [circularFileUrl, setCircularFileUrl] = useState(null);
  useEffect(() => {
    setCircularDate(new Date().toISOString().split("T")[0]);
  }, []);

  // const handleClear = () => {
  //   setCircularDate(new Date().toISOString().split("T")[0]);
  //   setCircularTime("");
  //   setIssuedBy(null);
  //   setCircularDetails("");
  //   setSendSmsTo("Both");
  //   setSendSms(false);
  //   setFlashCircular(false);
  //   setFlashSite(false);
  //   setDisplaySite(false);
  //   setApproved(false);
  //   setSelectAllClass(false);
  //   setSelectAllSection(false);
  //   setSelectAll(false);
  //   setSelectedInitiatedBy(""); // Reset the Issued By field

  //   // Clear the table data
  //   setFilteredMessages([]); // Reset filteredMessages state

  //   // Unmark all class checkboxes
  //   setClassSelections((prevState) =>
  //     Object.keys(prevState).reduce((acc, key) => {
  //       acc[key] = false;
  //       return acc;
  //     }, {})
  //   );

  //   // Unmark all section checkboxes
  //   setSelections((prevState) =>
  //     Object.keys(prevState).reduce((classAcc, classKey) => {
  //       classAcc[classKey] = Object.keys(prevState[classKey]).reduce(
  //         (sectionAcc, sectionKey) => {
  //           sectionAcc[sectionKey] = false;
  //           return sectionAcc;
  //         },
  //         {}
  //       );
  //       return classAcc;
  //     }, {})
  //   );
  //   window.location.reload();
  // };

  //New code 07242025
  const handleClear = () => {
    setCircularDate(new Date().toISOString().split("T")[0]);
    setCircularTime("");
    setIssuedBy(null);
    setCircularDetails("");
    setSendSmsTo("Both");
    setSendSms(false);
    setFlashCircular(false);
    setFlashSite(false);
    setDisplaySite(false);
    setApproved(false);
    setSelectAllClass(false);
    setSelectAllSection(false);
    setSelectAll(false);
    setSelectedInitiatedBy(""); // Reset the Issued By field

    // Clear the table data
    setFilteredMessages([]); // Reset filteredMessages state

    // Unmark all class checkboxes
    setClassSelections((prevState) =>
      Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {})
    );

    // Unmark all section checkboxes
    setSelections((prevState) =>
      Object.keys(prevState).reduce((classAcc, classKey) => {
        classAcc[classKey] = Object.keys(prevState[classKey]).reduce(
          (sectionAcc, sectionKey) => {
            sectionAcc[sectionKey] = false;
            return sectionAcc;
          },
          {}
        );
        return classAcc;
      }, {})
    );
    // window.location.reload();
  };

  useEffect(() => {
    if (classes.length > 0) {
      const initialSelections = Object.fromEntries(
        classes.map((classItem) => [classItem.classname, false])
      );
      setClassSelections(initialSelections);
    }
  }, [classes]);

  useEffect(() => {
    const initialSelections = classSections.reduce((acc, item) => {
      if (!acc[item.classname]) {
        acc[item.classname] = {};
      }
      acc[item.classname][item.sectionname] = null;
      return acc;
    }, {});

    setSelections(initialSelections);
  }, [classSections]);

  useEffect(() => {
    const loadInitiatedByOptions = async () => {
      const list = await fetchInitiatedByList();
      setInitiatedByList(list);
    };
    // loadMessageTypes();
    loadInitiatedByOptions();
  }, []);

  // const handleDisplay = () => {
  //   // Prepare selected class IDs
  //   const selectedClassIds = Object.keys(classSelections)
  //     .filter((className) => classSelections[className])
  //     .map((className) => classMapping[className]); // Map to IDs

  //   // Prepare selected section IDs
  //   const selectedSectionIds = Object.keys(selections).flatMap((classname) =>
  //     Object.keys(selections[classname])
  //       .filter((sectionname) => selections[classname][sectionname] === true)
  //       .map((sectionname) => sectionMapping[classname][sectionname])
  //   );

  //   // Capture the selected initiated by ID
  //   const selectedInitiatedById = initiatedBy || null;

  //   // Update filters state
  //   setFilters({
  //     classIds: selectedClassIds,
  //     sectionIds: selectedSectionIds,
  //     initiatedById: selectedInitiatedById,
  //   });

  //   // Fetch messages based on updated filters
  //   fetchCircularMessages(
  //     selectedClassIds,
  //     selectedSectionIds,
  //     selectedInitiatedById
  //   );

  //   // Show the table after filtering
  //   setIsTableVisible(true);
  // };

  // 09092025
  const handleDisplay = () => {
    const selectedClassIds = Object.keys(classSelections)
      .filter((className) => classSelections[className])
      .map((className) => classMapping[className]);

    const selectedSectionIds = Object.keys(selections).flatMap((classname) =>
      Object.keys(selections[classname])
        .filter((sectionname) => selections[classname][sectionname] === true)
        .map((sectionname) => sectionMapping[classname][sectionname])
    );

    const selectedInitiatedById = initiatedBy || null;

    // ✅ Include circularDate & circularDetails in filters
    setFilters({
      classIds: selectedClassIds,
      sectionIds: selectedSectionIds,
      initiatedById: selectedInitiatedById,
      circularDate,
      circularDetails,
    });

    // ✅ Pass them to fetch function
    fetchCircularMessages(
      selectedClassIds,
      selectedSectionIds,
      selectedInitiatedById,
      circularDate,
      circularDetails
    );

    setIsTableVisible(true);
  };

  useEffect(() => {
    fetchInitiatedByList();
    fetchCircularMessages(); // fetch circular data on load
    setIsTableVisible(true); // ✅ Show table immediately on page load
  }, []);

  // const fetchCircularMessages = async (
  //   classIds = [],
  //   sectionIds = [],
  //   initiatedById = null
  // ) => {
  //   const orgId = localStorage.getItem("orgId");
  //   const branchId = localStorage.getItem("branchId");
  //   const academicYearId = localStorage.getItem("academicSessionId");

  //   if (!orgId || !branchId || !academicYearId) {
  //     alert("Missing mandatory fields in local storage");
  //     return;
  //   }

  //   try {
  //     // Prepare base query parameters
  //     const params = new URLSearchParams({
  //       org_id: orgId,
  //       branch_id: branchId,
  //       academic_year_id: academicYearId,
  //     });

  //     // Dynamically add filters
  //     if (classIds.length > 0) {
  //       params.append("classIds", JSON.stringify(classIds));
  //     }

  //     if (sectionIds.length > 0) {
  //       params.append("sectionIds", JSON.stringify(sectionIds));
  //     }

  //     if (initiatedById) {
  //       params.append("initiatedby", initiatedById);
  //     }

  //     const queryString = params.toString();
  //     const url = ` ${ApiUrl.apiurl}CIRCULAR_MESSAGE/CIRCULARMESSAGEFilter/?${queryString}`;

  //     const response = await fetch(url);
  //     const data = await response.json();

  //     if (response.ok) {
  //       setCircularMessages(data.data);
  //       setFilteredMessages(data.data); // Filtered data for the table
  //     } else {
  //       alert("Error fetching circular messages");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // alert("An error occurred while fetching circular messages.");
  //   }
  // };

  //09092025
  const fetchCircularMessages = async (
    classIds = [],
    sectionIds = [],
    initiatedById = null,
    circularDate = "",
    circularDetails = ""
  ) => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicYearId = localStorage.getItem("academicSessionId");

    if (!orgId || !branchId || !academicYearId) {
      alert("Missing mandatory fields in local storage");
      return;
    }

    try {
      const params = new URLSearchParams({
        org_id: orgId,
        branch_id: branchId,
        academic_year_id: academicYearId,
      });

      if (classIds.length > 0)
        params.append("classIds", JSON.stringify(classIds));
      if (sectionIds.length > 0)
        params.append("sectionIds", JSON.stringify(sectionIds));
      if (initiatedById) params.append("initiatedby", initiatedById);

      // ✅ Add date & details filters
      if (circularDate) params.append("circular_date", circularDate);
      if (circularDetails) params.append("circular_details", circularDetails);

      const url = `${
        ApiUrl.apiurl
      }CIRCULAR_MESSAGE/CIRCULARMESSAGEFilter/?${params.toString()}`;

      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        let result = data.data || [];

        // ✅ Fallback filtering if backend ignores params
        if (circularDate) {
          result = result.filter(
            (msg) => msg.circular_date?.split("T")[0] === circularDate
          );
        }
        if (circularDetails) {
          result = result.filter((msg) =>
            msg.circular_details
              ?.toLowerCase()
              .includes(circularDetails.toLowerCase())
          );
        }

        setCircularMessages(result);
        setFilteredMessages(result);
      } else {
        alert("Error fetching circular messages");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const classMapping = classes.reduce(
    (acc, cls) => ({ ...acc, [cls.classname]: cls.id }),
    {}
  );

  const handleSelectAllClass = (event) => {
  const { checked } = event.target;
  setSelectAllClass(checked);

  setClassSelections((prevState) =>
    Object.keys(prevState).reduce((acc, key) => {
      acc[key] = checked;
      return acc;
    }, {})
  );

  if (!checked) {
    setSelections((prev) =>
      Object.keys(prev).reduce((classAcc, classKey) => {
        classAcc[classKey] = Object.keys(prev[classKey]).reduce(
          (sectionAcc, sectionKey) => {
            sectionAcc[sectionKey] = false;
            return sectionAcc;
          },
          {}
        );
        return classAcc;
      }, {})
    );
    setSelectAll(false);
  }
};

  const handleClassChange = (event) => {
  const { name, checked } = event.target;

  setClassSelections((prevState) => ({
    ...prevState,
    [name]: checked,
  }));

  if (!checked) {
    setSelections((prev) => ({
      ...prev,
      [name]: Object.keys(prev[name] || {}).reduce((acc, sectionName) => {
        acc[sectionName] = false;
        return acc;
      }, {}),
    }));
  }
};

  if (loading) return <p>Loading classes...</p>;
  if (error) return <p>{error}</p>;

  // Create a mapping of section names to section ids
  const sectionMapping = classSections.reduce((acc, item) => {
    if (!acc[item.classname]) {
      acc[item.classname] = {};
    }
    acc[item.classname][item.sectionname] = item.section_id;
    return acc;
  }, {});

  const handleSelectAll = (event) => {
  const isChecked = event.target.checked;
  setSelectAll(isChecked);

  setSelections((prev) => {
    const updatedSelections = Object.keys(prev).reduce((acc, classname) => {
      acc[classname] = Object.keys(prev[classname]).reduce(
        (sectionAcc, sectionname) => {
          sectionAcc[sectionname] = classSelections[classname] ? isChecked : false;
          return sectionAcc;
        },
        {}
      );
      return acc;
    }, {});
    return updatedSelections;
  });
};
  const handleSectionChange = (classname, sectionname) => (event) => {
    const isChecked = event.target.checked;

    setSelections((prev) => {
      const updatedSelections = {
        ...prev,
        [classname]: {
          ...prev[classname],
          [sectionname]: isChecked,
        },
      };

      // Update "Select All" checkbox based on whether all are checked
      const allSelected = Object.keys(updatedSelections).every((cls) =>
        Object.values(updatedSelections[cls]).every((val) => val)
      );
      setSelectAll(allSelected);

      return updatedSelections;
    });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  const handleSendSmsToChange = (event) => {
    setSendSmsTo(event.target.value);
  };

  // const handleSubmit = async () => {
  //   try {
  //     const academicYearId = localStorage.getItem("academicSessionId");
  //     const orgId = localStorage.getItem("orgId");
  //     const branchId = localStorage.getItem("branchId");
  //     const createdBy = sessionStorage.getItem("userId");

  //     // Validate required fields
  //     if (
  //       !academicYearId ||
  //       !circularDate ||
  //       !circularDetails ||
  //       !initiatedBy
  //     ) {
  //       alert("Please fill in all required fields.");
  //       return;
  //     }

  //     const formattedCircularDate = circularDate;
  //     const formattedCircularTime = circularTime ? `${circularTime}:00` : null;

  //     const selectedClassIds = Object.keys(classSelections)
  //       .filter((className) => classSelections[className])
  //       .map((className) => classMapping[className]);

  //     const selectedSectionIds = Object.keys(selections).flatMap((classname) =>
  //       Object.keys(selections[classname])
  //         .filter((sectionname) => selections[classname][sectionname] === true)
  //         .map((sectionname) => sectionMapping[classname][sectionname])
  //     );

  //     const payload = {
  //       academic_year_id: parseInt(academicYearId),
  //       classIds: selectedClassIds,
  //       sectionIds: selectedSectionIds,
  //       circularDate: formattedCircularDate,
  //       circularDetails,
  //       initiatedBy: parseInt(initiatedBy),
  //       orgId: parseInt(orgId),
  //       branchId: parseInt(branchId),
  //       circularStatus: approved ? "Y" : "N",
  //       send_sms: sendSms ? "Y" : "N",
  //       message_status: approved ? "A" : "P",
  //       circular_sent_to:
  //         sendSmsTo === "Both" ? "B" : sendSmsTo === "Father" ? "F" : "M",
  //       circular_time: formattedCircularTime,
  //       created_by: parseInt(createdBy),
  //       circular_file: null,
  //     };

  //     console.log("Payload to send:", payload);

  //     const response = await fetch(
  //       `${ApiUrl.apiurl}CIRCULAR_MESSAGE/Createcircularmessage/`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     if (response.ok) {
  //       const result = await response.json();
  //       alert(result.message || "Circular saved successfully!");
  //       resetForm();
  //       window.location.reload();
  //     } else {
  //       const error = await response.json();
  //       alert(error.message || "An error occurred.");
  //     }
  //   } catch (error) {
  //     console.error("Error during save:", error);
  //     alert("An unexpected error occurred. Please try again.");
  //   }
  // };

  //08292025
  const handleSubmit = async () => {
    try {
      const academicYearId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const createdBy = sessionStorage.getItem("userId");

      if (
        !academicYearId ||
        !circularDate ||
        !circularDetails ||
        !initiatedBy
      ) {
        alert("Please fill in all required fields.");
        return;
      }

      const formattedCircularDate = circularDate;
      const formattedCircularTime = circularTime ? `${circularTime}:00` : null;

      const selectedClassIds = Object.keys(classSelections)
        .filter((className) => classSelections[className])
        .map((className) => classMapping[className]);

      // const selectedSectionIds = Object.keys(selections).flatMap((classname) =>
      //   Object.keys(selections[classname])
      //     .filter((sectionname) => selections[classname][sectionname] === true)
      //     .map((sectionname) => sectionMapping[classname][sectionname])
      // );

      //  Group sectionIds by class
      const selectedSectionIds = Object.keys(selections)
        .map((classname) =>
          Object.keys(selections[classname])
            .filter(
              (sectionname) => selections[classname][sectionname] === true
            )
            .map((sectionname) => sectionMapping[classname][sectionname])
        )
        .filter((arr) => arr.length > 0); // Remove empty arrays

      //  Build FormData
      const formData = new FormData();
      formData.append("academic_year_id", academicYearId);
      formData.append("circularDate", formattedCircularDate);
      formData.append("circularDetails", circularDetails);
      formData.append("initiatedBy", initiatedBy);
      formData.append("orgId", orgId);
      formData.append("branchId", branchId);
      formData.append("circularStatus", approved ? "Y" : "N");
      formData.append("send_sms", sendSms ? "Y" : "N");
      formData.append("message_status", approved ? "A" : "P");
      formData.append(
        "circular_sent_to",
        sendSmsTo === "Both" ? "B" : sendSmsTo === "Father" ? "F" : "M"
      );
      if (formattedCircularTime) {
        formData.append("circular_time", formattedCircularTime);
      }
      formData.append("created_by", createdBy);

      //  Arrays as JSON
      formData.append("classId", JSON.stringify(selectedClassIds));
      formData.append("sectionId", JSON.stringify(selectedSectionIds));

      //  File in binary
      if (uploadCircular) {
        formData.append("circularFile", uploadCircular, uploadCircular.name);
      }

      console.log("FormData being sent:");
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(
        `${ApiUrl.apiurl}CIRCULAR_MESSAGE/Createcircularmessage/`,
        {
          method: "POST",
          body: formData, //  Send binary form-data
        }
      );

      if (response.ok) {
        const result = await response.json();
        alert(result.message || "Circular saved successfully!");
        resetForm();
        // 🔹 Refresh table with latest data
        fetchCircularMessages();
        setIsTableVisible(true);
      } else {
        const error = await response.json();
        alert(error.message || "An error occurred.");
      }
    } catch (error) {
      console.error("Error during save:", error);
      alert("An unexpected error occurred. Please try again.");
    }
  };

  // const resetForm = () => {
  //   setClassSelections({});
  //   setSelections({});
  //   setCircularDate("");
  //   setCircularTime("");
  //   setCircularDetails("");
  //   setInitiatedBy("");
  //   setSendSms(false);
  //   setSendSmsTo("");
  //   setFlashCircular(false);
  //   setFlashSite(false);
  //   setDisplaySite(false);
  //   setApproved(false);
  //   // setUploadCircular(null);
  // };

  const resetForm = () => {
    // Reset classes to false (unchecked)
    setClassSelections((prev) =>
      Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {})
    );

    // Reset sections to false (unchecked)
    setSelections((prev) =>
      Object.keys(prev).reduce((classAcc, classKey) => {
        classAcc[classKey] = Object.keys(prev[classKey]).reduce(
          (sectionAcc, sectionKey) => {
            sectionAcc[sectionKey] = false;
            return sectionAcc;
          },
          {}
        );
        return classAcc;
      }, {})
    );

    setCircularDate("");
    setCircularTime("");
    setCircularDetails("");
    setInitiatedBy("");
    setSendSms(false);
    setSendSmsTo("Both");
    setFlashCircular(false);
    setFlashSite(false);
    setDisplaySite(false);
    setApproved(false);

    // 🔹 Reset Issued By dropdown
    setSelectedInitiatedBy("");

    // 🔹 Reset uploadCircular state
    setUploadCircular(null);

    // 🔹 Clear file input field from DOM
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = "";
  };

  // const fetchCircularData = async (id) => {
  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}CIRCULAR_MESSAGE/GetcircularmessageBasedId/${id}`
  //     );
  //     const data = await response.json();
  //     if (data.message === "Success") {
  //       const circularData = data.data;
  //       // Update states with fetched data
  //       setCircularDate(circularData.circular_date);
  //       setCircularTime(circularData.circular_time);
  //       setCircularDetails(circularData.circular_details);
  //       setSendSms(circularData.send_sms === "Y"); // Convert "Y"/"N" to boolean
  //       setFlashCircular(circularData.flash_circular === "Y");
  //       setFlashSite(circularData.flash_site === "Y");
  //       setDisplaySite(circularData.display_site === "Y");
  //       setApproved(circularData.circular_status === "Y");
  //       // Update SMS recipients
  //       switch (circularData.sms_sent_to) {
  //         case "B":
  //           setSendSmsTo("Both");
  //           break;
  //         case "F":
  //           setSendSmsTo("Father");
  //           break;
  //         case "M":
  //           setSendSmsTo("Mother");
  //           break;
  //         default:
  //           setSendSmsTo("Both");
  //       }
  //       // Update class and section mappings
  //       setClassSelections({ [circularData.classname]: true });
  //       setSelections({
  //         [circularData.classname]: {
  //           [circularData.sectionname]: true,
  //         },
  //       });
  //       // Store classId and sectionId correctly in fetchedData
  //       setFetchedData({
  //         ...circularData,
  //         classId: circularData.classId, // Store classId
  //         sectionId: circularData.sectionId, // Store sectionId
  //       });
  //       setSelectedInitiatedBy(circularData.InitiatedById);
  //       setIsUpdateDisabled(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching circular data:", error);
  //   }
  // };

  // const handleEditClick = (id) => {
  //   fetchCircularData(id); // Fetch circular data
  //   setIsSaveDisabled(true); // Disable save button
  // };

  const fetchCircularData = async (id) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}CIRCULAR_MESSAGE/GetcircularmessageBasedId/${id}`
      );
      const data = await response.json();
      if (data.message === "Success") {
        const circularData = data.data;

        // Update form fields
        setCircularDate(circularData.circular_date);
        setCircularTime(circularData.circular_time);
        setCircularDetails(circularData.circular_details);
        setSendSms(circularData.send_sms === "Y");
        setFlashCircular(circularData.flash_circular === "Y");
        setFlashSite(circularData.flash_site === "Y");
        setDisplaySite(circularData.display_site === "Y");
        setApproved(circularData.circular_status === "Y");

        // Update SMS recipients
        switch (circularData.sms_sent_to) {
          case "B":
            setSendSmsTo("Both");
            break;
          case "F":
            setSendSmsTo("Father");
            break;
          case "M":
            setSendSmsTo("Mother");
            break;
          default:
            setSendSmsTo("Both");
        }

        // 🔹 Reset all classes & sections to false first
        setClassSelections((prev) =>
          Object.keys(prev).reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {})
        );

        setSelections((prev) =>
          Object.keys(prev).reduce((classAcc, classKey) => {
            classAcc[classKey] = Object.keys(prev[classKey]).reduce(
              (sectionAcc, sectionKey) => {
                sectionAcc[sectionKey] = false;
                return sectionAcc;
              },
              {}
            );
            return classAcc;
          }, {})
        );

        //  Then check the fetched class + section
        setClassSelections((prev) => ({
          ...prev,
          [circularData.classname]: true,
        }));

        setSelections((prev) => ({
          ...prev,
          [circularData.classname]: {
            ...prev[circularData.classname],
            [circularData.sectionname]: true,
          },
        }));

        // Store IDs for update
        setFetchedData({
          ...circularData,
          classId: circularData.classId,
          sectionId: circularData.sectionId,
        });
        // 🔹 Save the circular file URL for preview
        setCircularFileUrl(circularData.circular_file_url || null);
        setUploadCircular(null); // clear file input
        setSelectedInitiatedBy(circularData.InitiatedById);
        setIsUpdateDisabled(false);
      }
    } catch (error) {
      console.error("Error fetching circular data:", error);
    }
  };

  const handleEditClick = (id) => {
    fetchCircularData(id); // Fetch circular data
    setIsSaveDisabled(true); // Disable save button
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
  };

  // const updateCircularMessage = async (id) => {
  //   try {
  //     // Validate ID
  //     if (!id || typeof id !== "number") {
  //       console.error("Invalid ID passed to updateCircularMessage:", id);
  //       return;
  //     }

  //     // Fetch necessary values from storage
  //     const academicYearId = localStorage.getItem("academicSessionId");
  //     const orgId = localStorage.getItem("orgId");
  //     const branchId = localStorage.getItem("branchId");
  //     const updatedBy = sessionStorage.getItem("userId");

  //     // Validate critical mappings
  //     if (!classMapping || !sectionMapping) {
  //       console.error("classMapping or sectionMapping is undefined");
  //       return;
  //     }

  //     // Prepare selected class IDs
  //     const selectedClassIds = Object.keys(classSelections)
  //       .filter((className) => classSelections[className])
  //       .map((className) => classMapping[className]);

  //     // Extract section IDs from the selections state
  //     const selectedSectionIds = Object.keys(selections)
  //       .flatMap((className) =>
  //         Object.keys(selections[className] || {})
  //           .filter((sectionName) => selections[className][sectionName])
  //           .map(
  //             (sectionName) =>
  //               sectionMapping[className]
  //                 ? sectionMapping[className][sectionName]
  //                 : null // Safeguard against missing mappings
  //           )
  //       )
  //       .filter((id) => id !== null); // Remove null values

  //     // Debugging: Log selected IDs
  //     console.log("Selected Class IDs:", selectedClassIds);
  //     console.log("Selected Section IDs:", selectedSectionIds);

  //     // Use fetchedData.sectionId if no section is selected
  //     let sectionId =
  //       selectedSectionIds.length > 0 ? selectedSectionIds[0] : null;
  //     if (!sectionId) {
  //       sectionId = fetchedData?.sectionId || null; // Use sectionId from fetchedData
  //     }

  //     if (!sectionId) {
  //       console.error("No sectionId found for this circular update.");
  //       return;
  //     }

  //     // Prepare the payload
  //     const payload = {
  //       academic_year_id: academicYearId || null,
  //       class_id:
  //         selectedClassIds.length > 0
  //           ? selectedClassIds[0]
  //           : fetchedData?.classId || null,
  //       section_id: sectionId,
  //       circular_date: circularDate || null,
  //       circular_file: null, // Assuming no file for now
  //       circular_details: circularDetails || "",
  //       initiated_by: selectedInitiatedBy || null,
  //       org_id: orgId || null,
  //       branch_id: branchId || null,
  //       circular_status: approved ? "Y" : "N",
  //       send_sms: sendSms ? "Y" : "N",
  //       message_status: approved ? "A" : "P",
  //       circular_sent_to:
  //         sendSmsTo === "Both" ? "B" : sendSmsTo === "Father" ? "F" : "M",
  //       circular_time: circularTime || null,
  //       is_active: true, // Assuming active
  //       updated_by: updatedBy || null,
  //     };

  //     // Debugging: Log the final payload
  //     console.log("Payload to be sent:", payload);

  //     // Make the API call
  //     const response = await fetch(
  //       ` ${ApiUrl.apiurl}CIRCULAR_MESSAGE/updatecircularmessage/${id}`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     // Handle response
  //     if (!response.ok) {
  //       console.error("HTTP Error:", response.status, response.statusText);
  //       return;
  //     }

  //     const result = await response.json();

  //     if (result.message === "Circular Message updated successfully.") {
  //       console.log("Circular updated successfully:", result);
  //       alert("Circular Message updated successfully.");
  //       window.location.reload(); // Refresh the page
  //     } else {
  //       console.error("Failed to update circular:", result);
  //       alert("Failed to update circular. Please try again."); // Show error alert
  //     }
  //   } catch (error) {
  //     console.error("Error updating circular:", error);
  //     alert("An error occurred while updating the circular. Please try again."); // Show error alert
  //   }
  // };

  const updateCircularMessage = async (id) => {
    try {
      if (!id || typeof id !== "number") {
        console.error("Invalid ID passed to updateCircularMessage:", id);
        return;
      }

      const academicYearId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const updatedBy = sessionStorage.getItem("userId");

      // Prepare selected class IDs
      const selectedClassIds = Object.keys(classSelections)
        .filter((className) => classSelections[className])
        .map((className) => classMapping[className]);

      // Prepare section IDs
      const selectedSectionIds = Object.keys(selections)
        .flatMap((className) =>
          Object.keys(selections[className] || {})
            .filter((sectionName) => selections[className][sectionName])
            .map((sectionName) =>
              sectionMapping[className]
                ? sectionMapping[className][sectionName]
                : null
            )
        )
        .filter((id) => id !== null);

      let sectionId =
        selectedSectionIds.length > 0 ? selectedSectionIds[0] : null;
      if (!sectionId) {
        sectionId = fetchedData?.sectionId || null;
      }

      if (!sectionId) {
        console.error("No sectionId found for this circular update.");
        return;
      }

      // Use FormData instead of JSON
      const formData = new FormData();
      formData.append("academic_year_id", academicYearId || "");
      formData.append(
        "class_id",
        selectedClassIds.length > 0
          ? selectedClassIds[0]
          : fetchedData?.classId || ""
      );
      formData.append("section_id", sectionId);
      formData.append("circular_date", circularDate || "");
      formData.append("circular_details", circularDetails || "");
      formData.append("initiated_by", selectedInitiatedBy || "");
      formData.append("org_id", orgId || "");
      formData.append("branch_id", branchId || "");
      formData.append("circular_status", approved ? "Y" : "N");
      formData.append("send_sms", sendSms ? "Y" : "N");
      formData.append("message_status", approved ? "A" : "P");
      formData.append(
        "circular_sent_to",
        sendSmsTo === "Both" ? "B" : sendSmsTo === "Father" ? "F" : "M"
      );
      formData.append("circular_time", circularTime || "");
      formData.append("is_active", "true");
      formData.append("updated_by", updatedBy || "");

      //  Always send file in binary
      if (uploadCircular) {
        // New file selected
        formData.append("circular_file", uploadCircular, uploadCircular.name);
      } else if (circularFileUrl) {
        // No new file → fetch the existing file from URL and send as binary
        const response = await fetch(circularFileUrl);
        const blob = await response.blob();
        const filename = circularFileUrl.split("/").pop() || "file";
        formData.append("circular_file", blob, filename);
      }

      const response = await fetch(
        `${ApiUrl.apiurl}CIRCULAR_MESSAGE/updatecircularmessage/${id}`,
        {
          method: "PUT",
          body: formData, // send multipart form-data with file
        }
      );

      if (!response.ok) {
        console.error("HTTP Error:", response.status, response.statusText);
        return;
      }

      const result = await response.json();

      if (result.message === "Circular Message updated successfully.") {
        alert("Circular Message updated successfully.");
        resetForm();
        fetchCircularMessages();
        setIsTableVisible(true);

        //  Enable Save, disable Update again
        setIsSaveDisabled(false);
        setIsUpdateDisabled(true);

        //  Clear file states so preview disappears
        setUploadCircular(null);
        setCircularFileUrl(null);
      } else {
        alert("Failed to update circular. Please try again.");
      }
    } catch (error) {
      console.error("Error updating circular:", error);
      alert("An error occurred while updating the circular. Please try again.");
    }
  };

  const handleUpdateClick = (id) => {
    updateCircularMessage(id); // Ensure the `id` is passed correctly
  };

  const handleDeleteClick = async (id) => {
    try {
      if (!id) {
        alert("Invalid Circular ID!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this circular?"
      );
      if (!confirmDelete) return;

      const response = await fetch(
        ` ${ApiUrl.apiurl}CIRCULAR_MESSAGE/deletecircularmessage/${id}/`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (result.message === "Circular message Deleted Successfully") {
        alert("Circular message Deleted Successfully"); // Show success message
        // Refresh the filteredMessages after deletion
        setFilteredMessages(filteredMessages.filter((msg) => msg.id !== id));
      } else {
        alert("Failed to delete circular. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting circular:", error);
      alert("An error occurred while deleting the circular.");
    }
  };

  // const handleCancelClick = (id) => {
  //   // Update the state to mark the row as canceled
  //   const updatedMessages = filteredMessages.map((message) =>
  //     message.id === id ? { ...message, isCanceled: true } : message
  //   );

  //   setFilteredMessages(updatedMessages); // Update the state

  //   // Optionally, send a request to the server to persist the canceled status
  //   fetch(` ${ApiUrl.apiurl}CIRCULAR_MESSAGE/cancelcircularmessage/${id}/`, {
  //     method: "DELETE",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ isCanceled: true }),
  //   })
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.success) {
  //         console.log("Row canceled successfully.");
  //       } else {
  //         console.error("Failed to cancel the row.");
  //       }
  //     })
  //     .catch((error) => console.error("Error canceling row:", error));
  // };

  // Pagination logic
  // const offset = currentPage * itemsPerPage;
  // const currentPageData = filteredMessages.slice(offset, offset + itemsPerPage);
  // const pageCount = Math.ceil(filteredMessages.length / itemsPerPage);

  // 09152025
  const handleCancelClick = (id) => {
    const updatedMessages = filteredMessages.map((message) =>
      message.id === id
        ? { ...message, isCanceled: true, is_cancelled: true } // update both
        : message
    );

    setFilteredMessages(updatedMessages); // Update the state immediately

    // 🔹 Send request to the server
    fetch(`${ApiUrl.apiurl}CIRCULAR_MESSAGE/cancelcircularmessage/${id}/`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isCanceled: true }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          console.log("Row canceled successfully.");
        } else {
          console.error("Failed to cancel the row.");
        }
      })
      .catch((error) => console.error("Error canceling row:", error));
  };

  const safeMessages = Array.isArray(filteredMessages) ? filteredMessages : [];
  const offset = currentPage * itemsPerPage;
  const currentPageData = safeMessages.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(safeMessages.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                CIRCULAR ENTRY
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleDisplay}
                  >
                    Display
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSubmit}
                    disabled={isSaveDisabled}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => handleUpdateClick(fetchedData.id)}
                    disabled={isUpdateDisabled}
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="note mb-4 mt-4 ms-1 custom-section-box">
                <p style={{ fontSize: "14px" }}>Please Note:</p>
                <p style={{ fontSize: "14px" }}>
                  1. When Send SMS is selected, Circular details field length
                  will be limited to 159 characters.
                </p>
              </div>

              <div className="row g-3 circular-section-box custom-section-box ms-1">
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="circular-scroll-box">
                    <div className="circular-checkbox-group">
                      <input
                        type="checkbox"
                        checked={selectAllClass}
                        onChange={handleSelectAllClass}
                      />
                      <label>Select All Class *</label>
                    </div>
                    {Object.keys(classSelections).map((className) => (
                      <div className="checkbox-item" key={className}>
                        <input
                          type="checkbox"
                          name={className}
                          checked={classSelections[className]}
                          onChange={handleClassChange}
                        />
                        <label>{className}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div
                    className="circular-scroll-box"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    <div className="circular-checkbox-group mb-2">
                      {/* "Select All Section" Checkbox */}
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                      <label className="ms-1">Select All Section</label>
                    </div>

                    {Object.keys(selections).map((classname, index) => (
                      <div key={classname} className="class-section-group mb-3">
                        {/* Class Name */}
                        <h5 className="class-title mb-2">{classname}</h5>

                        {/* Section Names */}
                        <div className="section-list ms-3">
                          {Object.keys(selections[classname]).map(
                            (sectionname) => (
                              <div
                                className="checkbox-item mb-1"
                                key={`${classname}-${sectionname}`}
                              >
                                <input
  type="checkbox"
  name={sectionname}
  checked={selections[classname][sectionname]}
  disabled={!classSelections[classname]}
  onChange={handleSectionChange(classname, sectionname)}
/>
                                <label className="ms-1">{sectionname}</label>
                              </div>
                            )
                          )}
                        </div>

                        {/* Horizontal line between class groups */}
                        {index !== Object.keys(selections).length - 1 && (
                          <hr className="section-divider mt-3" />
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-3">
                  <div className="circular-form-group">
                    <label>Circular Date *</label>
                    <input
                      type="date"
                      value={circularDate}
                      onChange={(e) => setCircularDate(e.target.value)}
                    />
                  </div>
                  <div className="circular-form-group">
                    <label>Circular Time</label>
                    <input
                      type="time"
                      value={circularTime}
                      onChange={(e) => setCircularTime(e.target.value)}
                    />
                  </div>

                  <div className="circular-form-group">
                    <label>Issued By *</label>
                    <select
                      id="from-class"
                      className="form-select"
                      onChange={handleInitiatedByChange}
                      value={selectedInitiatedBy}
                    >
                      <option value="">Select initiated by</option>
                      {initiatedByList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.InitiatedBy_desc}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* <div className="circular-form-group">
                    <label>Upload Circular</label>
                    <input type="file" onChange={(e) => setUploadCircular(e.target.files[0])} />
                  </div> */}
                  <div className="circular-form-group">
                    <label>Upload Circular</label>
                    <input
                      type="file"
                      onChange={(e) => {
                        setUploadCircular(e.target.files[0]); // new file selected
                        setCircularFileUrl(null); // clear old preview if user chooses new
                      }}
                    />

                    {/* 🔹 Show preview if editing and file exists */}
                    {circularFileUrl && !uploadCircular && (
                      <div className="mt-2">
                        <p>Current File:</p>
                        {circularFileUrl.match(/\.(jpeg|jpg|png|gif)$/i) ? (
                          <img
                            src={circularFileUrl}
                            alt="Circular Preview"
                            style={{
                              maxWidth: "200px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <a
                            href={circularFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View File
                          </a>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="circular-form-group">
                    <label>Circular Details *</label>
                    <textarea
                      rows="4"
                      cols="40"
                      value={circularDetails}
                      maxLength={sendSms ? 159 : 5000}
                      onChange={(e) => setCircularDetails(e.target.value)}
                    ></textarea>
                  </div>
                  <div>
                    <p>
                      (No. of characters left:{" "}
                      {sendSms
                        ? 159 - circularDetails.length
                        : 5000 - circularDetails.length}
                      )
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <label className="form-label">Send SMS To</label>
                  <div className="d-flex flex-wrap mb-2">
                    {["Father", "Mother", "Both"].map((value) => (
                      <div
                        className="d-flex align-items-center me-3"
                        key={value}
                      >
                        <input
                          type="radio"
                          id={value.toLowerCase()}
                          name="sendSmsTo"
                          value={value}
                          checked={sendSmsTo === value}
                          onChange={handleSendSmsToChange}
                          className="me-1"
                        />
                        <label htmlFor={value.toLowerCase()} className="mb-0">
                          {value}
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      type="checkbox"
                      checked={sendSms}
                      onChange={(e) => setSendSms(e.target.checked)}
                      className="me-2"
                    />
                    <label className="mb-0">Send SMS</label>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      type="checkbox"
                      checked={approved}
                      onChange={(e) => setApproved(e.target.checked)}
                      className="me-2"
                    />
                    <label className="mb-0">Approved</label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ border: "1px solid #ccc" }}>
                  <div className="table-responsive">
                    {isTableVisible && (
                      <table className="table table-bordered ">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Circular Date</th>
                            <th>Circular Time</th>
                            <th>Class</th>
                            <th>Section</th>
                            <th>Issued By</th>
                            <th>Circular Details</th>
                            <th>Attachment</th>
                            <th>Send SMS</th>
                            <th>Approved</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            <th>Cancel</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(filteredMessages) &&
                          filteredMessages.length > 0 ? (
                            // filteredMessages.map((message, index) => (
                            //   <tr key={message.id}>
                            //     <td>{index + 1}</td>
                            currentPageData.map((message, index) => (
                              <tr key={message.id}>
                                <td>{offset + index + 1}</td>
                                <td>{message.circular_date}</td>
                                <td>
                                  {message.circular_time
                                    ? String(message.circular_time).slice(0, 8)
                                    : "N/A"}
                                </td>
                                <td>{message.classname}</td>
                                <td>{message.sectionname}</td>
                                <td>{message.InitiatedBy}</td>
                                <td>{message.circular_details || "N/A"}</td>
                                <td>
                                  {message.circular_file ? (
                                    <a
                                      href={message.circular_file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Download
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                                <td>
                                  {message.send_sms === "Y" ? "Yes" : "No"}
                                </td>
                                <td>
                                  {message.circular_status === "Y"
                                    ? "Yes"
                                    : "No"}
                                </td>
                                {/* <td>
                                  <button
                                    className="btn btn-primary"
                                    disabled={message.circular_status === "Y"}
                                    onClick={() => handleEditClick(message.id)}
                                  >
                                    Edit
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-danger"
                                    disabled={message.circular_status === "Y"}
                                    onClick={() =>
                                      handleDeleteClick(message.id)
                                    } // Call the function with message ID
                                  >
                                    Delete
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-warning"
                                    disabled={
                                      message.circular_status !== "Y" ||
                                      message.isCanceled
                                    }
                                    onClick={() =>
                                      handleCancelClick(message.id)
                                    }
                                  >
                                    {message.isCanceled ? "Canceled" : "Cancel"}
                                  </button>
                                </td> */}
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    disabled={
                                      message.is_cancelled ||
                                      message.circular_status === "Y"
                                    }
                                    onClick={() => handleEditClick(message.id)}
                                  >
                                    Edit
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-danger"
                                    disabled={
                                      message.is_cancelled ||
                                      message.circular_status === "Y"
                                    }
                                    onClick={() =>
                                      handleDeleteClick(message.id)
                                    }
                                  >
                                    Delete
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn btn-warning"
                                    disabled={
                                      message.is_cancelled ||
                                      message.circular_status !== "Y"
                                    }
                                    onClick={() =>
                                      handleCancelClick(message.id)
                                    }
                                  >
                                    {message.is_cancelled
                                      ? "Canceled"
                                      : "Cancel"}
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12">No records found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "pagination justify-content-center mt-3"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CircularEntry;